import React from 'react';
import './assets/css/admin.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './dashboard/Dashboard';
import Cobra from './cobra/Cobra';
import CobraSummary from './summary/CobraSummary';
import EmployeeBenefits from './pages/EmployeeBenefits';
import EmployeeBenefitsSummary from './summary/employeBenefits/EmployebenefitsSummary';
import FileUpload from './pages/FileUpload';
import Confirmation from './pages/Confirmation';
import Admin from './adminpanal/AdminPanal';
import AdminCasesTable from './adminpanal/AdminCasesTable';
import './assets/css/admin.css';
import AdminCasesWithDynamicFilters from './adminpanal/Admin';
import { PrintProvider } from './services/PrintProvider';
import TokenHandler from './services/TokenHandler';
function App() {
  return (
    
        <Routes>
          <Route path="/" element={<Navigate to="/token" />} />
        <Route path="/token" element={<TokenHandler requestType="Dashdoard" />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          
          <Route path="/Cobra/:caseId" element={<Cobra />} />
          <Route path="/CobraSummary/:caseId" element={<CobraSummary />} />
          <Route path="/EmployeeBenefits/:caseId" element={<EmployeeBenefits />} />
          <Route path="/EmployeeBenefitsSummary/:caseId" element={<EmployeeBenefitsSummary />} />  
          <Route path="/FileUpload/:caseId" element={<FileUpload/>} />
          <Route path="/Confirmation/:caseId" element={<Confirmation/>} />  
          <Route path="/Admin/token" element={<TokenHandler requestType="Admin"  />} />
          <Route path="/Admin" element={<Admin />} /> 
          <Route path="/NewAdmin" element={<AdminCasesWithDynamicFilters />} />     
        </Routes>
        
     
  );
}

export default App;
